import { Suspense, lazy, useEffect } from 'react';

import SessionChecker from '~/layout/components/SessionChecker';

import AppSpinner from 'components/AppSpinner';
import { OWN_DASHBOARD } from 'constants/featureToggle';
import { useAppDispatch, useAppSelector } from 'store';
import { uiAction } from 'ui/ui.actions';
import { getNavItems } from 'routes/routes';

const NavBar = lazy(() =>
  import('pages/layout/app/components/NavBar').then((module) => ({
    default: module.NavBar,
  }))
);
const NavBarV2 = lazy(() =>
  import('pages/layout/app/components/NavBar_v2').then((module) => ({
    default: module.NavBar,
  }))
);

const AppNavBar = () => {
  const dispatch = useAppDispatch();
  const isOwnDashboardFTEnabled =
    window.featureToggle?.isEnabled(OWN_DASHBOARD);

  const isAuthenticated = useAppSelector((state) => state.user.authenticated);
  const ownersPortalSettings = useAppSelector(
    (state) => state.user.ownersPortalSettings
  );

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(uiAction({ navItems: getNavItems({ ownersPortalSettings }) }));
    }
  }, [
    dispatch,
    isAuthenticated,
    ownersPortalSettings,
    isOwnDashboardFTEnabled,
  ]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <Suspense fallback={<AppSpinner />}>
      {isOwnDashboardFTEnabled ? <NavBarV2 /> : <NavBar />}
      <SessionChecker />
    </Suspense>
  );
};

export default AppNavBar;
